/* eslint-disable react/button-has-type */
import './ActionButton.scss';
import React, { MouseEvent, ReactNode } from 'react';
import classnames from 'classnames';
import ArrowIcon, { ARROW_TYPES } from '@mm/icons/general/ArrowIcon';

type Props = {
  children: string | ReactNode | Element[];
  className?: string;
  theme?: ButtonTheme;
  showActionCarrot?: boolean;
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => any;
  disabled?: boolean;
  type?: 'submit' | 'reset' | 'button';
  audacityLevel?: ButtonAudacityLevel;
  hoverEffect?: ButtonHoverType;
  css?: {
    buttonText?: string;
    buttonBackground?: string;
  };
};

export enum ButtonTheme {
  greenGradient = 'theme-green-gradient',
  blueOrangeGradient = 'theme-blue-orange-gradient',
  unicornGradient = 'theme-unicorn-gradient',
}

export enum ButtonAudacityLevel {
  timid = 'audacity-level--timid',
  bold = 'audacity-level--bold',
  hostile = 'audacity-level--hostile',
  none = 'audacity-level--none',
}

export enum ButtonHoverType {
  darken = 'hover-type-darken',
  raise = 'hover-type-raise',
}

const ARROW_COLORS = {
  [ButtonTheme.greenGradient]: '#fff',
  [ButtonTheme.blueOrangeGradient]: '#fff',
  [ButtonTheme.unicornGradient]: '#fff',
};

const ActionButton = (props: Props) => {
  const {
    children,
    className,
    theme,
    showActionCarrot,
    onClick,
    disabled,
    hoverEffect,
    type,
    css,
  } = props;
  const selectedHoverEffect = hoverEffect || ButtonHoverType.raise;
  const selectedTheme = theme || ButtonTheme.greenGradient;
  const audacityLevel = props.audacityLevel || ButtonAudacityLevel.bold;
  const classList = classnames(
    'action-button',
    className,
    `action-button--${selectedTheme}`,
    `action-button--${selectedHoverEffect}`,
    `action-button--${audacityLevel}`,
    {
      'action-button--disabled': disabled,
    },
  );
  const arrowColor = ARROW_COLORS[selectedTheme];

  const clickHandler = (e: MouseEvent<HTMLButtonElement>) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  return (
    <button className={classList} onClick={clickHandler} type={type}>
      <span className={classnames('action-button__text', css?.buttonText)}>
        {children}
      </span>

      {showActionCarrot && (
        <ArrowIcon
          arrowType={ARROW_TYPES.CHEVRON}
          direction="right"
          className="action-button__arrow"
          color={arrowColor}
        />
      )}

      <div
        className={classnames(
          'action-button__background',
          css?.buttonBackground,
        )}
      />
    </button>
  );
};

export { ActionButton };
